import { AppConfig } from './../../app.config';
import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { EODSignOff, UserProfileOperations, WebApiEndpoints, EODSignOffRequest } from '@liquitics/transaction';
import { AwsUtil } from '../../authentication/aws.service';
import * as moment from 'moment';
import { SnapshotService } from '../../snapshot/snapshot.service';


@Component({
    selector: 'app-eod-sign-off',
    templateUrl: './eod-sign-off.component.html',
    styleUrls: ['./eod-sign-off.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class EODSignOffComponent implements OnInit, OnDestroy {

    currentUsername: string;
    profile: UserProfileOperations;
    operatingDate: Date;
    batchIdentifier: string;


    eodSignOffs: EODSignOff[];
    selectedEODSignOffs: EODSignOff[];
    comments: string;

    showSubmitDialog = false;
    showApproveDialog = false;
    showRejectDialog = false;
    showInfo = false;
    loading = false;

    constructor(private awsUtil: AwsUtil,
        private appConfig: AppConfig,
        private snapshotService: SnapshotService) {
        this.currentUsername = this.awsUtil.jwtService.getUserCredentials().getUserName();
        this.profile = this.appConfig.activeUserProfile as UserProfileOperations;
        this.batchIdentifier = this.snapshotService.getDefaultBatchIdentifier();
        const biParts = this.batchIdentifier.split('_');
        this.operatingDate = moment.utc(biParts[0]).endOf('day').toDate();
    }
    async ngOnInit() {
        await this.refreshEODSignOff();
    }

    getBatchIdentifierForSelectedDate(): string {
        const biParts = this.batchIdentifier.split('_');
        biParts[0] = moment(this.operatingDate).format('YYYY-MM-DD');
        return biParts.join('_');
    }

    onOperatingDateSelected(event) {
        this.batchIdentifier = this.getBatchIdentifierForSelectedDate();
        this.refreshEODSignOff();
    }

    async refreshEODSignOff() {
        this.loading = true;
        try {
            this.eodSignOffs =
                (await this.awsUtil.webAPICall<EODSignOff[]>(WebApiEndpoints.QueryEODSignOffs,
                    {
                        type: 'GET',
                        batchIdentifier: this.batchIdentifier
                    } as EODSignOffRequest))
                    .map((eodSignOff) => {
                        eodSignOff.actionToTake = eodSignOff.actionToTake || 'NONE';
                        return eodSignOff;
                    });
        } catch (err) {
            console.log(err);
        } finally {
            this.loading = false;
        }
    }



    ngOnDestroy() {
    }


    onSubmit() {
    }


    async onActionConfirm(updateType: string) {
        await this.awsUtil.webAPICall<EODSignOff[]>(WebApiEndpoints.SaveEODSignOffs,
            {
                type: updateType,
                eodSignOffs: this.selectedEODSignOffs,

            } as EODSignOffRequest, true);

        this.showSubmitDialog = false;
        this.showApproveDialog = false;
        this.showRejectDialog = false;
        this.comments = undefined;
        await this.refreshEODSignOff();
    }

    async onSubmitConfirm() {
        await this.onActionConfirm('SUBMIT');
    }

    async onApproveConfirm() {
        await this.onActionConfirm('APPROVE');
    }

    async onRejectConfirm() {
        await this.onActionConfirm('REJECT');
    }

    // onInfo(record: RecordModification) {
    //     this.infoRecordModification = record;
    //     this.showInfo = true;
    // }
    // onLink(record: RecordModification) {
    //     const itemKeySplits = record.itemKey.split('/');
    //     const url = `https://s3.console.aws.amazon.com/s3/object/${itemKeySplits[2]}?prefix=${itemKeySplits.slice(3).join('/')}`;
    //     window.open(url, '_blank');
    // }

    updateEnabled(status: string) {
        if (this.selectedEODSignOffs && this.selectedEODSignOffs.length > 0) {
            const statusCount = this.selectedEODSignOffs
                .filter((rm) => {
                    return rm.status === status;
                })
                .length;
            return statusCount === this.selectedEODSignOffs.length;
        }
        return false;
    }

    // submitEnabled() {
    //     return this.updateEnabled('MODIFIED');
    // }
    approveEnabled() {
        return this.updateEnabled('PENDING');
    }
    // rejectEnabled() {
    //     return this.updateEnabled('PENDING');
    // }
}